import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Button, Card, CardActions, CardContent, Divider, Tooltip, Typography } from '@material-ui/core';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import InputIcon from '@material-ui/icons/Input';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import Badge from '@material-ui/core/Badge';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import DialogConfirmacao from '../../../../components/DialogConfirmacao/DialogConfirmacao';
import DialogContentText from '@material-ui/core/DialogContentText';
import Alert from '@material-ui/lab/Alert/Alert';


const useStyles = makeStyles(theme => ({
  root: {},
  details: {
    display: 'flex'
  },
  avatar: {
    marginLeft: 'auto',
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0
  },
  progress: {
    marginTop: theme.spacing(2)
  },
  uploadButton: {
    marginRight: theme.spacing(2)
  }
}));

const UsuarioProfileSummarized = props => {
  const {
    className,
    aoModificarImagemPerfil,
    usuario,
    openDialogChangePass,
    logout,
    deletarImagemPerfil,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,...rest } = props;
  const classes = useStyles();
  const [abrirDialogConfirmacaoApagarImagemPerfil, setAbrirDialogConfirmacaoApagarImagemPerfil] = useState(false);


  const SmallAvatar = withStyles((theme) => ({
    root: {
      width: 32,
      height: 32,
      border: `2px solid ${theme.palette.background.paper}`,
      backgroundColor: theme.palette.error.main
    },
  }))(Avatar);

  function confirmarDeleteImagem(e) {
    setAbrirDialogConfirmacaoApagarImagemPerfil(false);
    deletarImagemPerfil(e);
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid
          container
          spacing={1}
        >
          <Grid
            item
            md={12}
            xs={12}
          >
            <DialogConfirmacao
              mensagemBotaoEsquerda={'CANCELAR'}
              mensagemBotaoDireita='REMOVER'
              acaoBotaoEsquerda={() => {setAbrirDialogConfirmacaoApagarImagemPerfil(false)}}
              acaoBotaoDireita={e => confirmarDeleteImagem(e)}
              componenteExtraDialogContent={
                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <DialogContentText id={'mensagemPrincipalDialog'}>
                      {`Tem certeza que deseja remover a imagem do seu perfil?`}
                    </DialogContentText>
                  </Grid>
                </Grid>
              }
              tituloDialog={'Confirmação'}
              open={abrirDialogConfirmacaoApagarImagemPerfil}
            />
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            style={{
              display:'flex',
              justifyContent: 'center'
            }}
          >
            <Tooltip
              title={'Clique para editar a foto do seu perfil'}
              placement={'top'}
            >
              <Badge
                overlap="circle"
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                invisible={!usuario.imagemPerfil || !usuario.imagemPerfil.url}
                badgeContent={
                  <SmallAvatar
                    alt="Remover imagem"
                    onClick={e => setAbrirDialogConfirmacaoApagarImagemPerfil(true)}
                    style={{
                      cursor: 'pointer'
                    }}
                  >
                    <DeleteOutlineIcon style={{fontSize: 16}}/>
                  </SmallAvatar>
                }

              >
                <input
                  accept=".png, .jpg, .jpeg"
                  className={classes.input}
                  id="contained-button-file"
                  multiple={false}
                  type="file"
                  onChange={e => aoModificarImagemPerfil(e)}
                  style={{
                    display: 'none'
                  }}
                />
                <label htmlFor="contained-button-file">
                  <Avatar
                    style={{
                      width: 88,
                      height: 88,
                      cursor: "pointer"
                    }}
                    alt="Imagem do perfil"
                    src={usuario.imagemPerfil && usuario.imagemPerfil.url && usuario.imagemPerfil.url}
                  >
                  </Avatar>
                </label>

              </Badge>
            </Tooltip>
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            style={{
              display:'flex',
              justifyContent: 'center'
            }}
          >
            <Typography
              gutterBottom
              variant="h3"
            >
              {usuario.nomeFantasia}
            </Typography>
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
          >
            <Typography
              className={classes.locationText}
              color="textSecondary"
              variant="body1"
            >
              {usuario.createdAt ? `Data cadastro: ${moment(usuario.createdAt).format('DD/MM/YYYY hh:mm')}` : ''}
            </Typography>
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
          >
            <Typography
              className={classes.dateText}
              color="textSecondary"
              variant="body1"
            >
              {usuario.updatedAt ? `Ultima atualização: ${moment(usuario.updatedAt).format('DD/MM/YYYY hh:mm')}` : ''}
            </Typography>
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
          >
            <Typography
              className={classes.dateText}
              color="textSecondary"
              variant="body1"
            >
              {usuario.login ? `Login: ${usuario.login}` : ''}
            </Typography>
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
          >
            <Typography
              className={classes.dateText}
              color="textSecondary"
              variant="body1"
            >
              {usuario.email ? `Email: ${usuario.email}` : ''}
            </Typography>
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
          >
            <Typography
              className={classes.dateText}
              color="textSecondary"
              variant="body1"
            >
              {usuario.tipoUsuario ? `Tipo de usuário: ${usuario.tipoUsuario.descricao}` : ''}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardActions>
        {usuario.idUsuario &&
          <Button
            className={classes.uploadButton}
            color="primary"
            variant="outlined"
            onClick={e => openDialogChangePass()}
            startIcon={<VpnKeyIcon />}

          >
            Alterar senha
          </Button>
        }
        {usuario.idUsuario &&
        <Button
          variant="outlined"
          style={{
            color: 'red'
          }}
          className={classes.button}
          startIcon={<InputIcon />}
          onClick={logout}
        >
          Sair
        </Button>

        }

      </CardActions>
    </Card>
  );
};

UsuarioProfileSummarized.propTypes = {
  className: PropTypes.string
};

export default UsuarioProfileSummarized;
